/** Nomes traduzidos das telas usados pelo contexto e pelas ofertas de navegação. */

/** Rotas LITERAIS publicadas. Espelho de `ROTAS_PUBLICADAS_ASSISTENTE_V2`. */
export const CHAVE_POR_ROTA: Record<string, string> = {
  '/holidays': 'assistentePontotel.telas.gestaoCalendarioFeriados',
  '/holidays/create': 'assistentePontotel.telas.cadastroNovoFeriado',
  '/company/new': 'assistentePontotel.telas.cadastroNovoLocal',
  '/routine/list': 'assistentePontotel.telas.gestaoEscalas',
  '/gerenciamento-de-ferias': 'assistentePontotel.telas.gestaoFerias',
  '/gerenciamento-banco': 'assistentePontotel.telas.gestaoBancoDeHoras',
  '/painel-pontos': 'assistentePontotel.telas.correcaoDePonto',
  '/employee/list': 'assistentePontotel.telas.cadastroDeEmpregados',
  '/employer/list': 'assistentePontotel.telas.cadastroDeEmpregadores',
  '/company/list': 'assistentePontotel.telas.cadastroDeLocais',
  '/user': 'assistentePontotel.telas.gestaoDeUsuarios',
  '/user/create': 'assistentePontotel.telas.cadastroNovoUsuario',
  '/user-group': 'assistentePontotel.telas.gestaoDeGruposDeUsuarios',
  '/permissions/list': 'assistentePontotel.telas.gestaoDePerfisDePermissao',
  '/regras-de-notificacao': 'assistentePontotel.telas.gestaoDeRegrasDeNotificacao',
  '/workjourney': 'assistentePontotel.telas.gestaoDeJornadas',
  '/workjourney/create': 'assistentePontotel.telas.gestaoDeJornadas',
  '/regras-de-ferias': 'assistentePontotel.telas.gestaoDeRegrasDeFerias',
  '/fechamentos': 'assistentePontotel.telas.filaDeRelatorios',
  '/fechar-folha-em-conjunto': 'assistentePontotel.telas.fechamentoDeFolhaEmConjunto',
  '/approvals': 'assistentePontotel.telas.centralDeAprovacoes',
  '/gerenciamento-de-arquivos/list': 'assistentePontotel.telas.gestaoDeArquivos',
  '/coletores/listar': 'assistentePontotel.telas.gestaoDeColetores',
  '/regras-de-travamento/list': 'assistentePontotel.telas.regrasDeTravamento',
  '/verify-timesheet': 'assistentePontotel.telas.verificacaoDeFolha',
  '/reason/list': 'assistentePontotel.telas.motivosDeJustificativa',
  '/customizacoes-de-calculo/listar': 'assistentePontotel.telas.customizacoesDeCalculo',
  '/approvals-rules/list': 'assistentePontotel.telas.regrasDeAprovacao',
  '/fast': 'assistentePontotel.telas.alteracaoEmMassaDeEmpregados',
  '/deviceManage/list': 'assistentePontotel.telas.gestaoDeDispositivosDePonto',
  '/faturas': 'assistentePontotel.telas.faturasDaEmpresa',
  '/parametrizador/listar': 'assistentePontotel.telas.parametrizacaoDeVerbasE02',
  '/timeoff/list': 'assistentePontotel.telas.regrasDeBancoDeHoras',
  '/customizacoes-de-calculo/grupo-de-rubricas/criar': 'assistentePontotel.telas.cadastroDeGrupoDeRubricas',
  '/reason/new': 'assistentePontotel.telas.cadastroDeMotivoDeJustificativa',
  '/timeoff/new': 'assistentePontotel.telas.cadastroDeRegraDeBancoDeHoras',
  '/customizacoes-de-calculo/regra-de-calculo/criar': 'assistentePontotel.telas.cadastroNovaRegraDeCalculo',
  '/coletores/perfil/criar': 'assistentePontotel.telas.cadastroDePerfilDeColetor',
  '/permissions/new': 'assistentePontotel.telas.cadastroDePerfilDePermissoes',
  '/work-schedule': 'assistentePontotel.telas.planejamentoDeEscalas',
  '/face-biometric': 'assistentePontotel.telas.gestaoDeBiometriaFacial',
  '/employee/new': 'assistentePontotel.telas.cadastroNovoEmpregado',
  '/employer/new': 'assistentePontotel.telas.cadastroNovoEmpregador',
  '/employee/all': 'assistentePontotel.telas.alteracoesMultiplasDeEmpregados',
  '/dados': 'assistentePontotel.telas.dadosETravasDaEmpresa',
  '/routine/new': 'assistentePontotel.telas.cadastroNovaEscala',
  '/approvals-rules/new': 'assistentePontotel.telas.criacaoDeRegraDeAprovacao',
  '/regras-de-notificacao/new': 'assistentePontotel.telas.criacaoDeRegraDeNotificacao',
  '/regras-de-travamento/criacao': 'assistentePontotel.telas.criacaoDeRegraDeTravamento'
}

/**
 * Telas-detalhe: o registry as guarda como molde (`/employee/{id}`) e só o
 * servidor as preenche. Aqui o molde vira reconhecimento de forma — os
 * literais acima são consultados PRIMEIRO, senão `/employee/new` cairia em
 * `/employee/{id}` e a tela de cadastro novo viraria "Cadastro do empregado".
 */
export const PADROES_DE_ROTA: Array<{ padrao: RegExp, chave: string }> = [
  { padrao: /^\/gerenciamento-de-ferias\/empregado\/[0-9a-f]{24}$/, chave: 'assistentePontotel.telas.gestaoFerias' },
  { padrao: /^\/gerenciamento-banco\/empregado\/[0-9a-f]{24}$/, chave: 'assistentePontotel.telas.gestaoBancoDeHoras' },
  { padrao: /^\/holidays\/[0-9a-f]{24}$/, chave: 'assistentePontotel.telas.gestaoCalendarioFeriados' },
  { padrao: /^\/afast\/[^/]+$/, chave: 'assistentePontotel.telas.afastamentosEFeriasDoEmpregado' },
  { padrao: /^\/timesheet\/employee\/[^/]+\/[^/]+\/[^/]+$/, chave: 'assistentePontotel.telas.folhaDePontoDoEmpregado' },
  { padrao: /^\/timesheet\/work-place\/[^/]+\/[^/]+\/[^/]+$/, chave: 'assistentePontotel.telas.folhaDePontoDoLocalDeTrabalho' },
  { padrao: /^\/employee\/[^/]+$/, chave: 'assistentePontotel.telas.cadastroDoEmpregado' },
  { padrao: /^\/employer\/[^/]+$/, chave: 'assistentePontotel.telas.cadastroDoEmpregador' },
  { padrao: /^\/company\/[^/]+$/, chave: 'assistentePontotel.telas.cadastroDoLocalDeTrabalho' },
  { padrao: /^\/routine\/[^/]+$/, chave: 'assistentePontotel.telas.escalaDeTrabalho' },
  { padrao: /^\/permissions\/[^/]+$/, chave: 'assistentePontotel.telas.edicaoDePerfilDePermissoes' },
  { padrao: /^\/reason\/[^/]+$/, chave: 'assistentePontotel.telas.edicaoDeMotivoDeJustificativa' },
  { padrao: /^\/timeoff\/[^/]+$/, chave: 'assistentePontotel.telas.edicaoDeRegraDeBancoDeHoras' },
  { padrao: /^\/customizacoes-de-calculo\/regra-de-calculo\/[^/]+$/, chave: 'assistentePontotel.telas.regraDeCalculo' },
  { padrao: /^\/customizacoes-de-calculo\/grupo-de-rubricas\/[^/]+$/, chave: 'assistentePontotel.telas.edicaoDeGrupoDeRubricas' },
  { padrao: /^\/coletores\/perfil\/[^/]+$/, chave: 'assistentePontotel.telas.edicaoDePerfilDeColetor' },
  { padrao: /^\/approvals-rules\/[^/]+$/, chave: 'assistentePontotel.telas.regraDeAprovacao' },
  { padrao: /^\/regras-de-notificacao\/[^/]+$/, chave: 'assistentePontotel.telas.regraDeNotificacao' },
  { padrao: /^\/regras-de-travamento\/[^/]+$/, chave: 'assistentePontotel.telas.regraDeTravamento' },
  { padrao: /^\/gerenciamento-de-arquivos\/aprovacao\/[^/]+$/, chave: 'assistentePontotel.telas.aprovacaoDeArquivo' }
]

/**
 * Aceita a rota absoluta ou com hash, query e barra final.
 */
export function normalizarRota (rota: string): string {
  let caminho = rota.trim()
  if (!caminho) return ''

  const semEsquema = caminho.match(/^[a-z][a-z0-9+.-]*:\/\/[^/]*(\/.*)?$/i)
  if (semEsquema) caminho = semEsquema[1] || '/'
  if (caminho.startsWith('#')) caminho = caminho.slice(1)

  caminho = caminho.split('?')[0].split('#')[0]
  if (!caminho.startsWith('/')) caminho = `/${caminho}`
  if (caminho.length > 1 && caminho.endsWith('/')) caminho = caminho.slice(0, -1)
  return caminho
}

/** Chave do nome publicado, ou `null` quando a rota não é do conjunto. */
export function chaveDoNomeDaTela (rota: string | null | undefined): string | null {
  const caminho = normalizarRota(rota || '')
  if (!caminho) return null
  if (CHAVE_POR_ROTA[caminho]) return CHAVE_POR_ROTA[caminho]
  return PADROES_DE_ROTA.find(({ padrao }) => padrao.test(caminho))?.chave || null
}
